











import { Component, Mixins } from "vue-property-decorator";
import { LinkMixin } from "@/mixins/LinkMixin";

@Component
export default class AppFooter extends Mixins(LinkMixin) {
  get text() {
    const text = this.$t("app-footer.text") as string;
    if (!this.$vuetify.breakpoint.smAndUp) {
      return text.replace(".", ". <br />");
    }
    return text;
  }
}
